import { defineSlotRecipe } from '@chakra-ui/react';

export const rangePickerSlotRecipe = defineSlotRecipe({
    slots: ['box'],
    base: {
        box: {
            '--day-in-range-bg': '{colors.secondary.50}',
            '--day-range-selected': '{colors.secondary.solid}',
            '--day-range-hover': '{colors.secondary.800}',
            '--datepicker-border-color': '{colors.gray.200}',
        },
    },
});
